const otherInformationDescriptor = Object.freeze({
    type: 'other-information',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):step-8-label',
    fallbackTitle: 'Other information',
    defaultDescriptionKey: null,
    fallbackDescription: 'Add any additional information that should be included in the response.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: ['request.other-information', 'request.bulk-reply-candidates'],
        writes: ['request.other-information', 'request.bulk-reply-candidates'],
    },
    effects: {
        publishes: ['request.other-information.changed', 'request.bulk-reply-candidates.changed'],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showInstruction: { type: 'boolean', default: true },
        },
    },
    settingsUi: {
        showInstruction: { control: 'switch' },
    },
})

export { otherInformationDescriptor }
export default otherInformationDescriptor
